// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  width: 290px;
  box-shadow: 12px 6px 15px 0px #4f4545;
  border-radius: 2px;
  background-color: white;
}

.cardName {
  padding: 0;
  font-size: 24px;
  margin-top: 0;
  margin-bottom: 10px;
}

.cardInfo {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Card/Card.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".card {\n  width: 290px;\n  box-shadow: 12px 6px 15px 0px #4f4545;\n  border-radius: 2px;\n  background-color: white;\n}\n\n.cardName {\n  padding: 0;\n  font-size: 24px;\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n.cardInfo {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
